import { gql } from 'apollo-angular';

export const GET_ALL_VENDOR_INVOICES = gql`
  query findAllBillsWithPagination($input: BillPaginationInput) {
    findAllBillsWithPagination(input: $input) {
      bills {
        id
        billNo
        billStatus
        paymentStatus
        vendorData {
          id
          vendorName
        }
        accountId
        billDate
        dueDate
        subTotal
        tax
        totalAmount
        balance
        paidDate
      }
      total
      skip
      limit
    }
  }
`;

export const LIST_VENDORS = gql`
  query vendors($search: String) {
    vendors(search: $search) {
      id
      vendorName
      trn
      address
    }
  }
`;

export const LIST_ACCOUNTS = gql`
  query findAccountsByType($accountType: AccountType!, $search: String) {
    findAccountsByType(accountType: $accountType, search: $search) {
      id
      accountType
      accountName
      accountCode
    }
  }
`;

export const LIST_BILL_BY_ID = gql`
  query bill($id: Int!) {
    bill(id: $id) {
      id
      billNo
      vendorId
      vendorData {
        id
        vendorName
        address
      }
      accountId
      accountData {
        id
        accountName
        accountCode
      }
      billDate
      dueDate
      subTotal
      tax
      totalAmount
      paymentStatus
      balance
      billUrl
      billStatus
      status
      isApproved
      approvedOrRejectedBy
      purchaseOrderId
      billItems {
        id
        billId
        itemName
        description
        quantity
        rate
        tax
        totalAmount
        subTotal
      }
      journalData {
        id
        journalNo
        createdBy
        postedAt
        status
        date
        totalAmount
        journalEntries {
          id
          journalId
          journalData {
            id
            journalNo
          }
          debit
          accountData {
            accountName
          }
          credit
          description
        }
      }
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const GENERATE_BILL_PDF = gql`
  mutation generateBillPdf($billId: Int!) {
    generateBillPdf(billId: $billId)
  }
`;

export const GET_PURCHASE_ORDER_BY_VENDOR = gql`
  query purchaseOrders($input: PurchaseOrderPaginationInput) {
    purchaseOrders(input: $input) {
      purchaseOrders {
        id
        vendorId
        customerId
        purchaseOrderNo
        reference
        dueDate
        billDate
        customerNote
        status
        purchaseStatus
        totalAmount
        currencyData {
          currencyCode
        }
        exchangeRate
        purchaseItems {
          id
          purchaseOrderId
          itemName
          description
          quantity
          rate
          subTotal
          tax
          totalAmount
        }
      }
      total
      skip
      limit
    }
  }
`;
